import React from "react";
import Picture from "../../../shared/components/Picture";
import { CardBackground } from "../../../shared/svg/Svg";
import BlockFooter from "../../../shared/components/BlockFooter/BlockFooter";
import { useReactAppState } from "../../../shared/containers/utils";

function LeaderCardLoading({ cardType = "player", currentStatViewType, advertiser, statTableUrl }) {
  const { t } = useReactAppState();
  return (
    <div role="region" className="mls-o-leader-card">
      <div className="d3-o-media-object d3-o-media-object--vertical">
        <figure className="d3-o-media-object__figure" style={{ "--aspect-ratio": '1.5' }}>
          {
            cardType === "player"
              ? (
                <Picture extraClasses="mls-o-loading mls-o-loading--glow" src="/assets/images/Fallback-Headshot.png"
                  title={t("fallback_headshot")} />
              )
              : (
                <Picture extraClasses="mls-o-loading mls-o-loading--glow" src="/assets/images/Fallbacklogo-grey.png"
                  title={t("fallback_logo")} />
              )
          }
          <CardBackground extraClasses={"d3-o-media-object__background"} />
          <div className="d3-o-media-object__detail">
            <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--50" />
            {advertiser
              ? (
                <div role="complementary" className="d3-o-media-object__advertiser">
                  <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--20" />
                </div>
              ) : null
            }

            {
              cardType === "player"
                ? (
                  <div className="d3-o-media-object__club-logo">
                    <Picture extraClasses="mls-o-loading mls-o-loading--glow" src="/assets/images/Fallbacklogo-grey.png"
                      title={t("fallback_logo")} />
                  </div>
                )
                : null
            }
          </div>
        </figure>
        <div className="d3-o-media-object__body">
          <div data-testid="top ranked item" className="d3-o-media-object__rank d3-o-media-object__rank--top">
            <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--50" />
            <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--10" />
          </div>
          <div className="d3-o-media-object__ranked-list">
            {
              [...Array(3)].map((item, index) => {
                return (
                  <div data-testid="other ranked items" key={index}
                    className="d3-o-media-object__rank d3-o-media-object__rank--other">
                    <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--50" />
                    <div className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--10" />
                  </div>
                );
              })
            }
          </div>
          {
            statTableUrl && currentStatViewType
              ? <BlockFooter iconSize="small" link={statTableUrl} title={`${t("leader_card_full")}  ${currentStatViewType} ${t("leader_card_list")}`} />
              : null
          }
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line no-func-assign
LeaderCardLoading = React.memo(LeaderCardLoading);

export default LeaderCardLoading;
